import DoubleArrowIcon from '@mui/icons-material/DoubleArrow';

import { filterUndefined } from '../../../../../utils/FilterUndefinedObject';

const defaultProps = {
  causeComponent: null,
  effectComponent: null,
};

const CauseAndEffectPrompt = (p) => {
  const {
    causeComponent,
    effectComponent,
  } = { ...defaultProps, ...filterUndefined(p) };
  const createPlaceholder = (title, component) => (
    <div className='card-container'>
      <div className='card-container-placeholder item-placeholder'>
        <div className='title'>
          {title}
        </div>
        <div className='selected-card-container'>
          <div className='selected-card-container-inner'>
            {component}
          </div>
        </div>
      </div>
    </div>
  );

  return (
    <div className='cause-and-effect-prompt'>
      {createPlaceholder('Cause', causeComponent)}
      <div>
        <DoubleArrowIcon className='arrow' />
      </div>
      {createPlaceholder('Effect', effectComponent)}
    </div>
  );
};

export default CauseAndEffectPrompt;
